import { Card, Col, Container, Row } from "react-bootstrap";
import Button from "../components/button/index";
import '../scss/invoicing-for-individuals.style.scss';
import { useTranslation } from "react-i18next";
import { getItem, getLocalizedPathFromLocalStorage } from "../helper/localstorage.helper";
import { useNavigate } from "react-router-dom";
import { steps } from "../constant/invozing-for-individuals.constant";
import { InvoiceMobileWatch } from './images/png/icons';

export const InvoicingForIndividuals = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
const isLaptop = window.innerWidth >= 320 && window.innerWidth < 1440;
const isMobile = window.innerWidth < 576; // Bootstrap's mobile breakpoint
    return (
        <Container className=" d-flex align-items-center bg-gray-color">
            <Row className="w-100 d-flex flex-column-reverse flex-lg-row align-items-stretch justify-content-center row-padding-individuals">
                {/* Image Column */}
                <Col md={6} xs={12} lg={6} className={`d-flex px-0 half-stretch  `+ (isLaptop ? '' : '')}>
                    <img
                        src={InvoiceMobileWatch}
                        alt="Mobile Invoicing"
                        className="img-fluid"
                        style={{
                            borderRadius: "20px",
                            maxHeight: "100%",  // Optional: to limit image overflow
                        }}
                    />
                </Col>

                {/* Text Column */}
                <Col md={6} xs={12} sm={6} lg={6} className="  px-0 ">
                    <div className=" ml-auto" style={{
                        maxWidth: "684px",
                        width: "100%",
                    }}>
                        <h2 className={ `Heading_h2` + (isLaptop  ? ' mt-0  pt-0 pb-4' : ' pt-4 mt-1 mb-1 pb-4') + (isMobile ? 'pb-0 mb-0' : '')} >
                            {t("INVOICINGFORINDIVIDUALS_HEADING")}
                        </h2>
                        <h6 className={`section-subtitle ` + (isMobile ? 'pt-4 mt-2' : '' ) + (isLaptop ? ' pb-5' : ' mb-5')}>{t("INVOICINGFORINDIVIDUALS_SUB_HEADING")}</h6>
                        <Card className={`bg-transparent border-0 ` + (isLaptop ? 'mt-0' : 'mt-0')}>
                            {steps.map((step, idx) => (
                                <div key={step.number} className={`d-flex  position-relative ${ isLaptop ? ' mb-4 ' : 'mb-5 pb-2' }`}>
                                    <div>
                                        <div className="d-flex align-items-center justify-content-center text-dark mb-4 step-circle">
                                            {step.number}
                                        </div>
                                        {idx < steps.length - 1 && (
                                            <div className="mb-4 step-line" />
                                        )}
                                    </div>
                                    <div className="px-3 px-sm-5 d-flex align-items-start    flex-column">
                                        <h6 className={`fw-bold step-title mb-0 ${ isMobile ? 'mt-2' : ''}`}>{t(step.title)}</h6>
                                        <p className={` mb-0 Heading_h6 pr-0 ` + (isLaptop ? '' : 'pr-sm-5') + (isMobile && step.number == 4 ? 'pb-5' : '')}>{t(step.text)}</p>
                                    </div>
                                </div>
                            ))}
                            <Button
                                size="sm"
                                className={`d-sm-block d-none w-41 ` + (isLaptop ? '' : 'mt-2 ')}
                                variant="primary"
                                onClick={() =>
                                    navigate(
                                        getLocalizedPathFromLocalStorage(
                                            { get: (key: string) => getItem(key) ?? null },
                                            { 'sv-se': 'frilans-frilansarbete', 'en-us': 'freelance-freelancing' }
                                        )
                                    )
                                }
                            >
                                {t("INVOICINGFORINDIVIDUALS_BUTTON")}
                            </Button>
                        </Card>
                    </div>
                </Col>
            </Row>
        </Container>

    );
};

